import InvestStrategiesPage from './InvestStrategiesPage';

export default InvestStrategiesPage;
